/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Tips_TitleInputs */

const en_directory_ai_tools_tips_title = /** @type {(inputs: Directory_Ai_Tools_Tips_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photos that work best`)
};

const zh_directory_ai_tools_tips_title = /** @type {(inputs: Directory_Ai_Tools_Tips_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么样的照片效果最好`)
};

/**
* | output |
* | --- |
* | "Photos that work best" |
*
* @param {Directory_Ai_Tools_Tips_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_tips_title = /** @type {((inputs?: Directory_Ai_Tools_Tips_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Tips_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_tips_title(inputs)
	return zh_directory_ai_tools_tips_title(inputs)
});
export { directory_ai_tools_tips_title as "directory.ai_tools.tips_title" }